import 'bootstrap/dist/css/bootstrap.min.css';
import ContactForm from './ContactForm';
import { Trans, useTranslation } from 'react-i18next';
import image from '../../Assets/images/ContactImage.png';

export default function Contactus({ dir }) {
  const { t, i18n } = useTranslation();

  const TitleStyle = {
    borderRight: dir === 'rtl' ? '6px solid' : 'none',
    borderLeft: dir === 'ltr' ? '6px solid' : 'none',
  };

  return (
    <div className='contactRow'>
      <div className="container-fluid">
        <div className="row justify-content-evenly">
          <div className="col-md-11 headlineContainer">
            <h2 className="Title px-2 my-3 wow fadeInLeft" data-wow-delay="0.3s">
              <div className='indicator'></div>
              <Trans i18nKey="ContactTitle">تواصل معنا</Trans>
            </h2>
          </div>
          <div className="col-md-11">
            <h3 className="px-2 wow fadeIn justify-margin" data-wow-delay="0.6s">
              <Trans i18nKey="ContactSubTitle">
                نحن هنا لمساعدتك! تواصل معنا الآن وسنرد عليك في أقرب وقت ممكن
              </Trans>
            </h3>
          </div>
        </div>
        
        <div className="row justify-content-evenly mt-5">
          <div className="col-md-11">
            <div className="row justify-content-between align-items-center">
              {/* Contact Form Column */}
              <div className="col-lg-6 col-xl-6 my-4">
                <ContactForm />
              </div>
              
              {/* Image Column */}
              <div className="col-lg-6  wow fadeIn" data-wow-delay="0.6s">
                <div className="image-container" style={{
                  maxWidth: '100%',
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <img 
                    src={image} 
                    alt="Scales of justice representing legal consultation services" 
                    style={{
                      width: '100%',
                      height: 'auto',
                      maxHeight: '800px',
                      objectFit: 'contain', 
                      objectPosition: 'center'
                    }}
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}